import { combineReducers } from "redux";
import dataReducer from "./dataReducer";
import userReducer from "./userReducer";
import userApiReducer from "./userApiReducer";
import selectedOptionsReducer from "./selectedOptionsReducer";
import ticketReducer from "./ticketHistoryReducer";
import loadingReducer from "./loadingReducer";
import tabReducer from "./tabReducer";

const reducers = combineReducers({
  data: dataReducer,
  user: userReducer,
  userapi: userApiReducer,
  selectedOptions: selectedOptionsReducer,
  ticket: ticketReducer,
  loading: loadingReducer,
  tabs: tabReducer
});

export default reducers;
